import {get, apiRoutes} from '../../api/api';

export const REQUEST_ELEMENT_ANNOTATIONS = 'REQUEST_ELEMENT_ANNOTATIONS';
export const RECEIVE_ELEMENT_ANNOTATIONS = 'RECEIVE_ELEMENT_ANNOTATIONS';
export const REQUEST_ANNOTATION = 'REQUEST_ANNOTATION';
export const RECEIVE_ANNOTATION = 'RECEIVE_ANNOTATION ';

export function fetchElementAnnotations(id) {
  return dispatch => {
    dispatch(requestElementAnnotations(id));
    const url = apiRoutes.elements.getAnnotations(id);
    return get(url, function (response) {
      dispatch(receiveElementAnnotations(id, response.data));
    });
  };
}

function requestElementAnnotations(id) {
  return {
    type: REQUEST_ELEMENT_ANNOTATIONS,
    id: id
  };
}

function receiveElementAnnotations(id, data) {
  return {
    type: RECEIVE_ELEMENT_ANNOTATIONS,
    item: data,
    id: id,
    receivedAt: Date.now()
  };
}

function requestAnnotation(id) {
  return {
    type: REQUEST_ANNOTATION,
    id: id
  };
}

function receiveAnnotation(id, data) {
  return {
    type: RECEIVE_ANNOTATION,
    item: data,
    id: id,
    receivedAt: Date.now()
  };
}

export function fetchAnnotation(id) {
  return dispatch => {
    dispatch(requestAnnotation(id));
    const url = apiRoutes.annotations.get(id);
    return get(url, function (response) {
      dispatch(receiveAnnotation(id, response.data));
    });
  };
}



/** WEBPACK FOOTER **
 ** ./src/modules/annotations/actions.js
 **/